import React from "react";
import { Card, CardContent } from "./ui/card";
import { Star } from "lucide-react";
import { mockTestimonials } from "../mock";

const TestimonialsSection = () => {
  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Star
        key={index}
        className={`w-5 h-5 ${
          index < rating ? "text-yellow-400 fill-current" : "text-gray-400"
        }`}
      />
    ));
  };

  return (
    <section id="testimonials" className="py-20 bg-black">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            What Our Members 
            <span className="text-red-600"><i> Say </i></span>
          </h2>
          <p className="text-gray-300 text-xl">
            Real stories from members, parents, and fighters about their experiences
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto mb-16">
          {mockTestimonials.map((testimonial) => (
            <Card key={testimonial.id} className="bg-red-600 border-red-600/20 h-full">
              <CardContent className="p-6 h-full flex flex-col">
                {/* Rating */}
                <div className="flex items-center mb-4">
                  {renderStars(testimonial.rating)}
                </div>

                {/* Quote */}
                <blockquote className="text-gray-300 text-lg leading-relaxed mb-6 flex-grow">
                  "{testimonial.text}"
                </blockquote>

                {/* Author */}
                <div className="flex items-center">
                  <img 
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-12 h-12 rounded-full object-cover mr-4"
                  />
                  <div>
                    <h4 className="text-white font-semibold">{testimonial.name}</h4>
                    <p className="text-black text-sm">
                      {testimonial.role} • Age {testimonial.age}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="bg-red-600 text-white p-8 rounded-lg max-w-4xl mx-auto text-center">
          <h3 className="text-2xl font-bold mb-4">Join Our Boxing Family</h3>
          <p className="text-red-100 text-lg leading-relaxed mb-6">
            "At Clara Boxing Academy, we don't just train fighters - we build character, 
            confidence, and community. Every member becomes part of our extended family, 
            and we celebrate each other's victories both in and out of the ring."
          </p>
          <div className="mt-6">
            <span className="text-red-200 font-semibold">- The Clara Family</span>
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-8 text-center">
          <div className="bg-red-600 p-6 rounded-lg border border-white/20">
            <div className="text-red-600 text-3xl mb-4">⭐</div>
            <h4 className="text-white font-bold text-xl mb-2">5.0 Rating</h4>
            <p className="text-gray-300">Based on member feedback</p>
          </div>
          
          <div className="bg-red-600 p-6 rounded-lg border border-white/20">
            <div className="text-red-600 text-3xl mb-4">👥</div>
            <h4 className="text-white font-bold text-xl mb-2">50+ Members</h4>
            <p className="text-gray-300">And growing every month</p>
          </div>
          
          <div className="bg-red-600 p-6 rounded-lg border border-white/20">
            <div className="text-red-600 text-3xl mb-4">🏆</div>
            <h4 className="text-white font-bold text-xl mb-2">Champions Trained</h4>
            <p className="text-gray-300">Multiple amateur and pro winners</p>
          </div>
        </div>

        <div className="mt-16 text-center">
          <p className="text-gray-400 mb-6">Ready to write your own success story?</p>
          <button 
            onClick={() => document.querySelector('#contact').scrollIntoView({ behavior: 'smooth' })}
            className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-lg font-bold uppercase tracking-wide transition-all duration-300 transform hover:scale-105"
          >
            Start Your Journey Today
          </button>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;